const Link = {
  github: 'https://github.com/apmcoin/',
  twitter: 'https://twitter.com/apmcoin',
  medium: 'https://medium.com/apmcoin',
  telegram: 'https://t.me/apmcoin_ann',
};

export default Link;
